import React, { useEffect, useState } from "react";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import userPlaceholder from "../../assets/images/placeholder.jpg";
import Loader from "../../components/shared/Loader";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { updateMeta } from "../../store/actions/metaAction";

const BlogCreate = () => {
	const auth = useSelector(state => state.auth.user);
	const history = useHistory();
	const [title, setTitle] = useState("");
	const [description, setDescription] = useState("");
	const [descriptionEn, setDescriptionEn] = useState("");
	const [titleEn, setTitleEn] = useState("");
	const [picture, setPicture] = useState(userPlaceholder);
	const [loading, setLoading] = useState(true);
	const [link , setLink] = useState("");
	const [categories, setCategories] = useState([]);
	const [selectedCategory, setSelectedCategory] = useState(0);
	const [pageTitle, setPageTitle] = useState({
		ar: "",
		en: ""
	});
	const [pageDescription, setPageDescription] = useState({
		ar: "",
		en: ""
	})
	const dispatch = useDispatch();

	let editor = null;

	useEffect(() => {
		onStart();
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "اضافة مقال جديد",
				breadcrumb: "المدونة",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
		axios
			.get(`${process.env.REACT_APP_API_URL}/blog_categories`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				setCategories(response.data.data);
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};

	const handlePicture = () => {
		const fileInput = document.querySelector("#picture");
		setPicture(URL.createObjectURL(fileInput.files[0]));
	};

	const handleSubmit = e => {
		e.preventDefault();
		if (selectedCategory == 0) {
			toast.error("برجاء اختيار التصنيف أولا!");
			return;
		}
		const picture = document.querySelector("#picture");
		if (picture.files[0]) {
			setLoading(true);
			const data = new FormData();
			data.append("file", picture.files[0]);
			axios
				.post(`${process.env.REACT_APP_API_URL}/upload`, data, {
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
						"Content-Type": "multipart/form-data",
					},
				})
				.then(response => {
					axios
						.post(
							`${process.env.REACT_APP_API_URL}/blogs`,
							{
								title: { ar: title, en: titleEn },
								description: { ar: description, en: descriptionEn },
								admin_id: auth.id,
								category_id: parseInt(selectedCategory),
								image: response.data.data.name,
								page_url_title: link,
								page_title: pageTitle,
								page_description: pageDescription 
							},
							{
								headers: {
									Authorization: `Bearer ${cookie.get("token")}`,
									Accept: "application/json",
								},
							}
						)
						.then(function (response) {
							toast.success("تم اضافة المقالة بنجاح!");
							history.push("/blog/index");
							setLoading(false);
						})
						.catch(function (error) {
							toast.error("خطأ، برجاء المحاولة مره اخرى!");
							setLoading(false);
						});
				})
				.catch(error => {
					toast.error("خطأ في رفع الصورة، برجاء المحاولة مرة أخرى!");
					setLoading(false);
				});
		} else {
			toast.error("برجاء اختيار الصورة أولا!");
		}
	};

	return (
		<section>
			{loading && <Loader />}
			<form onSubmit={handleSubmit}>
				<div className="row">
					<div className="col-md-9">
						<div className="card">
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="category">التصنيف</label>
									<select
										id="category"
										onChange={e => setSelectedCategory(e.target.value)}
									>
										<option value="0">اختر التصنيف</option>
										{categories.map(category => (
											<option value={category.id} key={category.id}>
												{category.name}
											</option>
										))}
									</select>
								</div>
								<div className="form-item">
									<label htmlFor="title">العنوان</label>
									<input
										type="text"
										id="title"
										required
										value={title}
										onChange={e => setTitle(e.target.value)}
									/>
								</div>
								<div className="form-item">
									<label htmlFor="titleEn">العنوان الانجليزي</label>
									<input
										type="text"
										id="titleEn"
										required
										dir="ltr"
										style={{ direction: "ltr" }}
										value={titleEn}
										onChange={e => setTitleEn(e.target.value)}
									/>
								</div>
								<div className="form-item">
									<label htmlFor="link"> الرابط</label>
									<input
										type="text"
										id="link"
										// required
										dir="ltr"
										style={{ direction: "ltr" }}
										value={link}
										onChange={e => setLink(e.target.value)}
									/>
								</div>
								{/* title page */}
								<div className="row">
								<div className="form-item col-md-6">
									<label htmlFor="page_title_ar"> عنوان الصفحة بالعربي</label>
									<input
										type="text"
										id="page_title_ar"
										// required
										dir="rtl"
										style={{ direction: "rtl" }}
										value={pageTitle.ar}
										onChange={e => setPageTitle((prev)=>({ar: e.target.value, en: prev.en}))}
									/>
								</div>
								<div className="form-item col-md-6">
									<label htmlFor="page_title_en"> عنوان الصفحة بالانجليزي</label>
									<input
										type="text"
										id="page_title_en"
										// required
										dir="ltr"
										style={{ direction: "ltr" }}
										value={pageTitle.en}
										onChange={e => setPageTitle((prev)=>({ar: prev.ar, en: e.target.value}))}
									/>
								</div>
								</div>
								<div className="row">
								<div className="form-item col-md-6">
									<label htmlFor="page_description_ar"> وصف الصفحة بالعربي</label>
									<textarea
										type="text"
										id="page_description_ar"
										// required
										rows="5"
										dir="rtl"
										style={{ direction: "rtl" }}
										value={pageDescription.ar}
										onChange={e => setPageDescription((prev)=>({ar: e.target.value, en: prev.en}))}
									/>
								</div>
								<div className="form-item col-md-6">
									<label htmlFor="page_description_en"> وصف الصفحة بالانجليزي</label>
									<textarea
										type="text"
										id="page_description_en"
										// required
										rows="5"
										dir="ltr"
										style={{ direction: "ltr" }}
										value={pageDescription.en}
										onChange={e => setPageDescription((prev)=>({ar: prev.ar, en: e.target.value}))}
									/>
								</div>
								</div>
								<div className="form-item">
									<label htmlFor="description">النص</label>
									<CKEditor
										onReady={editor => {
											editor.ui
												.getEditableElement()
												.parentElement.insertBefore(
													editor.ui.view.toolbar.element,
													editor.ui.getEditableElement()
												);
											editor = editor;
										}}
										onError={({ willEditorRestart }) => {
											if (willEditorRestart) {
												editor.ui.view.toolbar.element.remove();
											}
										}}
										onChange={(event, editor) => {
											const data = editor.getData();
											setDescription(data);
										}}
										editor={DecoupledEditor}
										config={{
											contentsLangDirection: "rtl",
											language: "ar",
										}}
									/>
								</div>
								<div className="form-item">
									<label htmlFor="descriptionEn"> النص الانجليزي</label>
									<CKEditor
										onReady={editor => {
											editor.ui
												.getEditableElement()
												.parentElement.insertBefore(
													editor.ui.view.toolbar.element,
													editor.ui.getEditableElement()
												);
											editor = editor;
										}}
										onError={({ willEditorRestart }) => {
											if (willEditorRestart) {
												editor.ui.view.toolbar.element.remove();
											}
										}}
										onChange={(event, editor) => {
											const data = editor.getData();
											setDescriptionEn(data);
										}}
										editor={DecoupledEditor}
										config={{
											contentsLangDirection: "ltr",
											language: "en",
										}}
									/>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-3">
						<div className="card">
							<div className="card-body">
								<div className="form-item">
									<input type="file" onChange={handlePicture} id="picture" />
									<img src={picture} alt="avatar" className="imagePreview" />
								</div>
							</div>
						</div>
						<div className="form-item mt-3">
							<button className="bt bt-success btn-block">ارسال</button>
						</div>
					</div>
				</div>
			</form>
		</section>
	);
};

export default BlogCreate;
